import { render } from "./CleanMode.vue?vue&type=template&id=5c097341&scoped=true"
import script from "./CleanMode.vue?vue&type=script&lang=js"
export * from "./CleanMode.vue?vue&type=script&lang=js"

import "./CleanMode.vue?vue&type=style&index=0&id=5c097341&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c097341"]])

export default __exports__